/**
 * The roles that carry a claim desk.
 *
 * ⚠️ ONE definition, imported by every user picker. It was eight copies of the same two strings,
 * and the reason it is one now is the way the gap was found: `claim-filer` and `claim-assessor`
 * existed in the database, showed on the roles screen with their display names, and could not be
 * assigned to anybody — because each picker filters `list-roles` through an allowlist of role NAMES
 * written by hand, and a role is invisible to a screen until somebody adds it to that screen's list.
 *
 * It was reported twice, by people opening a form and not finding the role. The second report is
 * what made this file: a third would have been the same bug again.
 *
 * This does NOT make the pickers show the same roles — each keeps its own list and adds this to it.
 * What it removes is the chance of the pair drifting apart, or of a future rename reaching seven
 * screens out of eight.
 *
 * The real fix is bigger than a shared array: the API knows which roles exist and this app guesses
 * which may be assigned. Until a role can say that for itself, this is the honest version.
 */
export const CLAIM_DESK_ROLES = ['claim-filer', 'claim-assessor'];

export default CLAIM_DESK_ROLES;
